export default __webpack_public_path__ + "static/functionalVocationalTRaining-b5049cb157c8633ae93713884aed873d.jpg";